<template>
    <div class="card col-12 p-2 p-lg-3">
        <div class="d-flex mb-4">
            <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
                <input type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off" checked @click="change_date_type(0)">
                <label class="btn btn-outline-primary" for="btnradio1">即時</label>
                <input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off" @click="change_date_type(1)">
                <label class="btn btn-outline-primary" for="btnradio2">歷史</label>
            </div>
            <button class="ms-auto btn btn-warning" @click="export_csv()">CSV</button>
        </div>
        <div id="plot_div" style="position: relative;"></div>
        <div class="row g-0">
            <div class="col-12 col-md-10 col-lg-3 col-xl-3 col-xxl-2 mb-2 pe-lg-2">
                <select class="form-select" v-model="date_range" @change="search()">
                    <option :value="1" >日</option>
                    <option :value="2" >月</option>
                    <option :value="3" >年</option>
                    <option :value="4" >歷年</option>
                    
                </select>
            </div>
            <div class="col-12 col-lg-9 col-xl-9 col-xxl-10 mb-2" v-if="date_type == 1">
                <label>搜尋區間</label>
                <date-picker class="col-12 col-md-9 col-lg-9 col-xl-8 col-xxl-7" v-model="date1" type="date" 
                value-type="format" format="YYYY-MM-DD"
                range placeholder="請選擇搜尋區間" :clearable="false" @change="search()"
                :disabled-date="(date) => date >= new Date()"></date-picker>
            </div>
            
        </div>
    </div>
</template>
<script>
import DatePicker from "vue2-datepicker"
import "vue2-datepicker/index.css"
import "vue2-datepicker/locale/zh-tw"
import moment from "moment"
import Plotly from "plotly.js"

export default{
    components:{
        DatePicker
    },
    data(){
        return {
            date1: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
            date_range: 1,
            date_type: 0,
            plot_type: "scatter", 
            pv_plant_ID_list: [],
            dict1: [],
               
        }
    },
    methods:{
        search(){
            let that = this
            this.axios.get('/dmy_get_compare_data',{
                params:{
                    'pv_plant_ID_list': this.pv_plant_ID_list.join(','),
                    'datepicker1': this.date1[0],
                    'datepicker2': this.date1[1],
                    'date_range': this.date_range
                }
            }).then(function(data){
                console.log(data.data.data)
                let alldata = data.data.data['return_dict']
                that.dict1 = alldata
                let plot_data = []
                let layout = {
                    width: document.getElementById('plot_div').clientWidth,
                    height: document.getElementById('plot_div').clientHeight,
                    margin: that.plot_margin(),
                    title: {
                        text: 'DMY',
                        font: {
                        family: "Courier New, monospace",
                        size: 24,
                        },
                    },
                    xaxis:{
                        title: {
                        text: 'Date',
                        font: {
                            family: 'Courier New, monospace',
                            size: 18,
                            color: '#7f7f7f'
                        }
                        },
                        
                        tickangle: 'auto',
                    },
                    yaxis:{
                        title: {
                        text: '小時(h)',
                        font: {
                            family: 'Courier New, monospace',
                            size: 18,
                            color: '#7f7f7f'
                        }
                        },
                    },
                    legend: that.get_legend(),
                }
                for(var i in alldata){
                    alldata[i]['type'] = 'scatter'
                    //data_name = alldata[i]['name']
                    /* alldata[i]['hovertemplate'] = `<b style="color: black; display: flex;justify-content: center;
                        align-items: center;">◾</b>%{y: .3f}<extra>${data_name}</extra>` */
                    alldata[i]['mode'] = 'lines+markers'
                    alldata[i]['marker'] = {"size": 12}
                    plot_data.push(alldata[i])
                }
                Plotly.newPlot("plot_div", plot_data, layout, {
                displaylogo: false,
                modeBarButtonsToRemove: [
                    "sendDataToCloud",
                    "hoverClosestCartesian",
                    "hoverCompareCartesian",
                    "toggleSpikelines",
                ],
                })
            })
            
        },
        export_csv(){
            let alldata = this.dict1
            let keys = Object.keys(alldata)
            if(keys.length === 0){
                alert("無資料")
                return false
            }
            let data_length = alldata[keys[0]]['x'].length // Using length og first element as reference
            var header = "number,time"
            for(var ii in keys){
                header += (','+alldata[keys[ii]]['name'])
            }
            header += "\n"
            var str1 = ""
            for(var i=0; i<data_length; i+=1){
                str1 += (parseInt(i+1))
                for(var ii in keys){
                    if(ii == 0){
                        str1 += (','+ alldata[keys[ii]]['x'][i] )
                    }
                    str1 += (','+ alldata[keys[ii]]['y'][i])
                }
                str1 += '\n'
            }
            //Export CSV
            let csv_data = header + str1
            var fileName = "DMY比較_"+this.date1[0]+"_"+
            (this.date_type == 1 ? this.date1[2]+"_":"")
            +{'1': '日','2': '月', '3': '年', '4': '歷年'}[this.date_range]
            +".csv";//匯出的檔名
            var blob = new Blob(["\ufeff",csv_data], {
                type : "application/octet-stream"
            })
            var href = URL.createObjectURL(blob)
            var link = document.createElement("a")
            document.body.appendChild(link)
            link.href = href
            link.download = fileName
            link.click()
                    
        },
        change_date_type(type){
            this.date_type = type
            if(type == 0){
                this.date1 = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
            }
            this.search()
        },
        plot_resize(){
            let update = {
                width: "",
                heigth: "",
            }
            update = {
                width: document.getElementById('plot_div').clientWidth,
                height:  document.getElementById('plot_div').clientHeight,
                margin: this.plot_margin(),
                legend: this.get_legend()
            }
            Plotly.relayout("plot_div", update)
        },
        get_legend(){
            if(document.getElementById('plot_div').clientWidth < 992){
                return   {"x": 0, "y": -1}
            }else{
                return {"x": 0, "y": 1}
            }
            
        },
        plot_margin(){
            let margin =  {
                l: 80,
                r: 50,
                b: 40,
                t: 50,
                pad: 4,
            }
            if(document.getElementById('plot_div').clientWidth < 992){
                margin.l = 40
                margin.r = 1
                margin.b = 2
                margin.pad = 0
            }
            return margin
        },
    },
    mounted(){
        let that = this
        this.axios.get("/pv_plant_information")
        .then(function (data) {
            // 帶入params
            that.plant_information = {}
            for(var i in data.data.information){
                if(['屏東佳冬段', '花蓮綜開段', '台南七股段'].includes(data.data.information[i]['name'])){
                    continue
                }
                that.pv_plant_ID_list.push(data.data.information[i]['_id'])

            }
            that.search()
            //console.log(that.plant_information)
        })
        window.addEventListener("resize", this.plot_resize)
    },
    destroyed(){
        window.removeEventListener("resize", this.plot_resize)
    },
}
</script>
<style scoped>
#plot_div{
    min-height: 60vh;
}
@media(max-width: 991px){
    #plot_div{
        min-height: 80vh;
    }
}
</style>
